import { render, staticRenderFns } from "./hospitalarchives.vue?vue&type=template&id=091d63c3&scoped=true&"
import script from "./hospitalarchives.vue?vue&type=script&lang=js&"
export * from "./hospitalarchives.vue?vue&type=script&lang=js&"
import style0 from "./hospitalarchives.vue?vue&type=style&index=0&id=091d63c3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "091d63c3",
  null
  
)

export default component.exports